import './thenaughtygreek/style';
import FormStructure from './thenaughtygreek/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js